(() => {
'use strict';
if (window.NSQuizChatDock) return;
const root = document.documentElement;
const PROP = '--shopify-chat-activator-offset';
let popup, host, saved, base, applied = false, frame = 0;
const motion = document.createElement('style');
motion.textContent = `
    shopify-chat { transition: ${PROP} 220ms cubic-bezier(.22,.61,.36,1); }
    @media (prefers-reduced-motion: reduce) { shopify-chat { transition-duration: 0s; } }
  `;
(document.head || root).appendChild(motion);
function restore() {
  if (!applied) return;
  if (saved.value) host.style.setProperty(PROP, saved.value, saved.priority);
  else host.style.removeProperty(PROP);
  applied = false;
}
function queue() {
  if (!frame) frame = requestAnimationFrame(update);
}
const resize = new ResizeObserver(queue);
function update() {
  frame = 0;
  const next = document.getElementById('ns-quiz-popup'), chat = document.querySelector('shopify-chat');
  if (next !== popup) {
    resize.disconnect();
    popup = next;
    if (popup) resize.observe(popup);
  }
  if (chat !== host) {
    restore();
    host = chat;
    if (host) {
      saved = { value: host.style.getPropertyValue(PROP),
        priority: host.style.getPropertyPriority(PROP) };
      base = parseFloat(getComputedStyle(host).getPropertyValue(PROP)) || 20;
    }
  }
  if (!host) return;
  if (!popup) return restore();
  for (let node = popup; node; node = node.parentElement) {
    const css = getComputedStyle(node);
    if (node.hidden || css.display === 'none' ||
        ['hidden', 'collapse'].includes(css.visibility) ||
        css.contentVisibility === 'hidden') return restore();
  }
  const vv = window.visualViewport;
  const h = root.clientHeight || innerHeight;
  const w = root.clientWidth || innerWidth;
  const top = vv?.offsetTop || 0, left = vv?.offsetLeft || 0;
  const rect = popup.getBoundingClientRect();
  if (!(rect.width > 0 && rect.height > 0 && rect.bottom > top &&
      rect.top < Math.min(h, vv ? top + vv.height : h) &&
      rect.right > left && rect.left < Math.min(w, vv ? left + vv.width : w)))
    return restore();
  let edge = rect.top;
  const css = getComputedStyle(popup);
  if (css.transform !== 'none' && css.animationName.split(', ').includes('ns-qp-in'))
    edge -= Math.max(0, new DOMMatrixReadOnly(css.transform).m42);
  const target = Math.min(Math.max(0, h - top - 64), Math.max(base, h - edge + 12));
  const value = `${Math.ceil(target * 100) / 100}px`;
  if (host.style.getPropertyValue(PROP) !== value)
    host.style.setProperty(PROP, value, saved.priority);
  applied = true;
}
new MutationObserver(records => {
  if (records.some(r => r.target !== host || r.attributeName !== 'style')) queue();
}).observe(root, {
  subtree: true, childList: true, attributes: true,
  attributeFilter: ['hidden', 'class', 'style']
});
for (const type of ['resize', 'scroll', 'pageshow']) window.addEventListener(type, queue, true);
for (const type of ['resize', 'scroll']) window.visualViewport?.addEventListener(type, queue);
for (const type of ['animationend', 'transitionend', 'animationcancel', 'transitioncancel']) document.addEventListener(type, event => {
  if (popup && event.target instanceof Element && event.target.contains(popup)) queue();
}, true);
document.addEventListener('load', queue, true);
document.fonts?.ready.then(queue);
document.fonts?.addEventListener('loadingdone', queue);
window.NSQuizChatDock = { refresh: queue };
queue();
})();
